var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-image":"linear-gradient(60deg, #08182b 0%, #2c2b2b 100%)"}},[_c('GalleryWrapper',{attrs:{"slideshow":_vm.slideshow}}),_c('GalleryControls',{on:{"next":_vm.nextSlide,"prev":_vm.prevSlide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }